<template>
  <div class="shop-list-container">
    <!-- 搜索筛选区域 -->
    <el-card class="filter-card" shadow="never">
      <el-form :inline="false" :model="searchForm" class="filter-form" label-width="70px">
        <el-row :gutter="16">
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <el-form-item label="商家名称">
              <el-input v-model="searchForm.sh_name" placeholder="请输入商家名称" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <el-form-item label="商户号">
              <el-input v-model="searchForm.id" placeholder="请输入商户号" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <el-form-item label="审核状态">
              <el-select v-model="searchForm.audit_status" placeholder="全部" clearable>
                <el-option label="待审核" value="审核中"></el-option>
                <el-option label="已通过" value="审核通过"></el-option>
                <el-option label="审核未过" value="审核未过"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="24">
            <el-form-item>
              <el-button type="primary" @click="handleSearch" icon="el-icon-search">搜索</el-button>
              <el-button @click="resetSearch" icon="el-icon-refresh-right">重置</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <!-- 数据表格 -->
    <el-card class="table-card" shadow="never">
      <div slot="header" class="table-header">
        <span>店铺列表</span>
        <span class="total-info">共 {{ total }} 条记录</span>
      </div>
      <div class="table-scroll-wrapper">
        <el-table
          v-loading="loading"
          :data="tableData"
          height="56vh"
          border
          stripe
          style="width: 100%"
          :default-sort="{prop: 'id', order: 'descending'}"
          class="scrollable-table"
          :cell-style="cellStyle"
        >
          <el-table-column prop="sh_name" label="商家名称" min-width="140" show-overflow-tooltip></el-table-column>

          <el-table-column prop="sh_img" label="logo" width="70" align="center">
            <template slot-scope="scope">
              <el-avatar
                :src="scope.row.sh_img || 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'"
                :size="36"
                @error="handleAvatarError"
              >
                <i class="el-icon-picture-outline"></i>
              </el-avatar>
            </template>
          </el-table-column>

          <el-table-column prop="id" label="商户号" min-width="120" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.id || '--' }}
            </template>
          </el-table-column>

          <el-table-column prop="comlist_v2_2" label="省市" min-width="100" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.comlist_v2_2 || '--' }}
            </template>
          </el-table-column>

          <el-table-column prop="comlist_v5" label="经营范围" min-width="160" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.comlist_v5 || '--' }}
            </template>
          </el-table-column>

          <el-table-column prop="sh_rank" label="商户等级" width="100" align="center">
            <template slot-scope="scope">
              <el-tag :type="rankType(scope.row.sh_rank)" effect="plain" size="small">
                {{ rankName(scope.row.sh_rank) }}
              </el-tag>
            </template>
          </el-table-column>

          <el-table-column prop="audit_status" label="审核状态" width="90" align="center">
            <template slot-scope="scope">
              <el-tag :type="auditStatusType(scope.row.sh_type)" effect="dark" size="small">
                {{ auditStatusName(scope.row.sh_type) }}
              </el-tag>
            </template>
          </el-table-column>

          <!-- 操作列：仅保留编辑 -->
          <el-table-column label="操作" min-width="100" align="center">
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                icon="el-icon-edit"
                @click="openEditDialog(scope.row)"
              >
                审核
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页组件 -->
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          :small="isSmallScreen"
        >
        </el-pagination>
      </div>
    </el-card>

    <!-- 编辑审核状态弹窗（含只读信息） -->
    <el-dialog
      title="修改审核状态"
      :visible.sync="editDialogVisible"
      width="70%"
      :close-on-click-modal="false"
      @close="closeEditDialog"
    >
      <div v-if="currentEditShop" class="edit-content">
        <h3 class="shop-title">{{ currentEditShop.sh_name }} (ID: {{ currentEditShop.id }})</h3>
        <el-divider></el-divider>

        <!-- 只读信息展示 -->
        <el-descriptions
          :column="2"
          border
          size="small"
          class="info-descriptions"
          :label-style="{ width: '120px' }"
        >
          <el-descriptions-item label="企业名称">
            {{ currentEditShop.comlist_v9 || '--' }}
          </el-descriptions-item>
          <el-descriptions-item label="统一社会信用代码">
            {{ currentEditShop.comlist_v10 || '--' }}
          </el-descriptions-item>
          <el-descriptions-item label="营业执照有效期">
            {{ currentEditShop.comlist_v11 || '--' }}
          </el-descriptions-item>
          <el-descriptions-item label="法人姓名">
            {{ currentEditShop.comlist_v13 || '--' }}
          </el-descriptions-item>
          <el-descriptions-item label="身份证号">
            {{ currentEditShop.comlist_v14 || '--' }}
          </el-descriptions-item>
          <el-descriptions-item label="身份证有效期">
            {{ currentEditShop.comlist_v15 || '--' }}
          </el-descriptions-item>
          <el-descriptions-item label="营业执照" :span="2">
            <el-image
              v-if="currentEditShop.zhi_img"
              :src="currentEditShop.zhi_img"
              :preview-src-list="[currentEditShop.zhi_img]"
              fit="cover"
              style="width: 100px; height: 100px; border-radius: 4px;"
              @error="handleAvatarError"
            >
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
            <span v-else>--</span>
          </el-descriptions-item>
        </el-descriptions>

        <el-divider></el-divider>

        <!-- 审核状态修改表单 -->
        <el-form
          :model="editForm"
          label-width="100px"
          size="small"
          ref="editFormRef"
          :rules="editRules"
          label-position="right"
        >
          <el-form-item label="审核状态" prop="sh_type">
            <el-select v-model="editForm.sh_type" placeholder="请选择审核状态">
              <el-option label="审核中" value="审核中"></el-option>
              <el-option label="审核通过" value="审核通过"></el-option>
              <el-option label="审核未过" value="审核未过"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitEdit" :loading="editSubmitting">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import Cookie from 'js-cookie'

const token = Cookie.get('token')
const dlRequest = axios.create({
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
    comlistToken: token
  }
})
const editRequest = axios.create({
  withCredentials: true,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
    'X-Requested-With': 'XMLHttpRequest',
    comlistToken: token
  }
})
const BRAND_ID = localStorage.getItem('sh_id')

export default {
  name: 'ShopListManage',
  data () {
    return {
      loading: false,
      tableData: [],
      total: 0,
      page: 1,
      limit: 20,
      searchForm: {
        sh_name: '',
        id: '',
        audit_status: ''
      },
      editDialogVisible: false,
      currentEditShop: null,
      editForm: {
        sh_type: ''
      },
      editSubmitting: false,
      editRules: {
        sh_type: [
          { required: true, message: '请选择审核状态', trigger: 'change' }
        ]
      },
      isSmallScreen: false
    }
  },
  mounted () {
    this.fetchShopList()
    this.checkScreenSize()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    // 获取列表
    async fetchShopList () {
      this.loading = true
      try {
        const params = {
          a: 'lists',
          sh_id: BRAND_ID,
          page: this.page,
          page_size: this.limit,
          sh_name: this.searchForm.sh_name || '',
          id: this.searchForm.id || '',
          sh_type: this.searchForm.audit_status || ''
        }
        const response = await dlRequest.post('https://caixiao.lianglianyn.com/admin/shenhe_jiben.php', params)
        if (response.data && response.data.code === '0') {
          const list = response.data.data || response.data.list || []
          this.tableData = list
          this.total = response.data.data?.total || response.data.total || list.length
        } else {
          this.$message.error(response.data?.msg || '获取列表失败')
        }
      } catch (error) {
        console.error('请求异常:', error)
        this.$message.error('网络请求失败，请稍后重试')
      } finally {
        this.loading = false
      }
    },

    // 搜索
    handleSearch () {
      this.page = 1
      this.fetchShopList()
    },

    // 重置搜索
    resetSearch () {
      this.searchForm = {
        sh_name: '',
        id: '',
        audit_status: ''
      }
      this.page = 1
      this.fetchShopList()
    },

    // 分页
    handleSizeChange (val) {
      this.limit = val
      this.page = 1
      this.fetchShopList()
    },
    handleCurrentChange (val) {
      this.page = val
      this.fetchShopList()
    },

    // 等级映射
    rankName (rank) {
      const map = { 1: '普通商户', 2: '高级商户', 3: '金牌商户', 4: '旗舰商户' }
      return map[rank] || '普通商户'
    },
    rankType (rank) {
      const typeMap = { 1: 'info', 2: 'success', 3: 'warning', 4: 'danger' }
      return typeMap[rank] || 'info'
    },

    // 审核状态映射
    auditStatusName (status) {
      const map = { 审核中: '待审核', 审核通过: '已通过', 审核未过: '审核未过' }
      return map[status] || status || '未知'
    },
    auditStatusType (status) {
      const typeMap = { 审核中: 'warning', 审核通过: 'success', 审核未过: 'danger' }
      return typeMap[status] || 'info'
    },

    handleAvatarError () {
      return false
    },

    // 打开编辑弹窗
    openEditDialog (row) {
      this.currentEditShop = row
      this.editForm.sh_type = row.sh_type || ''
      this.editDialogVisible = true
      this.$nextTick(() => {
        if (this.$refs.editFormRef) {
          this.$refs.editFormRef.clearValidate()
        }
      })
    },

    // 提交审核状态修改
    submitEdit () {
      this.$refs.editFormRef.validate(async (valid) => {
        if (!valid) return
        this.editSubmitting = true
        try {
          const params = {
            a: 'editpass',
            parent_id: BRAND_ID,
            sh_main_id: this.currentEditShop.id,
            sh_type: this.editForm.sh_type

          }
          const response = await editRequest.post('https://caixiao.lianglianyn.com/admin/shenhe_jiben.php', params)
          if (response.data && response.data.code === '0') {
            this.$message.success('审核状态更新成功')
            this.editDialogVisible = false
            this.fetchShopList()
          } else {
            this.$message.error(response.data?.msg || '更新失败')
          }
        } catch (error) {
          console.error('修改审核状态异常:', error)
          this.$message.error('网络错误，请重试')
        } finally {
          this.editSubmitting = false
        }
      })
    },

    closeEditDialog () {
      this.currentEditShop = null
      this.editForm.sh_type = ''
      if (this.$refs.editFormRef) {
        this.$refs.editFormRef.resetFields()
      }
    },

    cellStyle () {
      return this.isSmallScreen ? { padding: '6px 0' } : {}
    },

    handleResize () {
      this.checkScreenSize()
    },
    checkScreenSize () {
      this.isSmallScreen = window.innerWidth < 768
    }
  }
}
</script>

<style lang="scss" scoped>
.shop-list-container {
  padding: 0 16px;
  background-color: #f0f2f6;
  height: 85vh;
  overflow: auto;
  box-sizing: border-box;
  @media (max-width: 768px) {
    padding: 12px;
  }

  .filter-card {
    // margin-bottom: 16px;
    border-radius: 8px;
    ::v-deep .el-card__body {
      padding: 16px;
      @media (max-width: 768px) {
        padding: 12px;
      }
    }
    .filter-form {
      ::v-deep .el-form-item {
        margin-bottom: 12px;
        width: 100%;
        .el-form-item__label {
          width: 70px;
          font-size: 13px;
        }
        .el-form-item__content {
          flex: 1;
        }
      }
    }
  }

  .table-card {
    border-radius: 8px;
    ::v-deep .el-card__header {
      padding: 12px 16px;
      @media (max-width: 768px) {
        padding: 10px 12px;
      }
    }
    ::v-deep .el-card__body {
      padding: 16px;
      @media (max-width: 768px) {
        padding: 12px;
      }
    }
    .table-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-weight: 600;
      font-size: 15px;
      .total-info {
        font-size: 12px;
        color: #909399;
        font-weight: normal;
      }
    }
    .table-scroll-wrapper {
      width: 100%;
      overflow-x: auto;
      overflow-y: hidden;
      &::-webkit-scrollbar {
        height: 8px;
      }
      &::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 4px;
      }
      &::-webkit-scrollbar-thumb {
        background: #c1c1c1;
        border-radius: 4px;
        &:hover {
          background: #a8a8a8;
        }
      }
      .scrollable-table {
        width: 100%;
        @media (max-width: 768px) {
          ::v-deep .el-table__header-wrapper,
          ::v-deep .el-table__body-wrapper {
            font-size: 12px;
          }
          ::v-deep .el-table__body td {
            font-size: 12px;
          }
          ::v-deep .el-tag {
            font-size: 10px;
            padding: 0 6px;
            height: 20px;
            line-height: 18px;
          }
          ::v-deep .el-button--mini {
            padding: 5px 8px;
            font-size: 11px;
            .el-icon-edit {
              font-size: 11px;
            }
          }
        }
        ::v-deep .el-table .cell {
          white-space: nowrap;
        }
      }
    }
  }

  .pagination-container {
    margin-top: 16px;
    display: flex;
    justify-content: flex-end;
    @media (max-width: 768px) {
      justify-content: center;
      ::v-deep .el-pagination {
        .el-pagination__total,
        .el-pagination__sizes,
        .el-pagination__jump {
          display: none;
        }
        .btn-prev,
        .btn-next,
        .el-pager li {
          min-width: 28px;
          height: 28px;
          line-height: 28px;
          font-size: 12px;
        }
      }
    }
  }

  .edit-content {
    .shop-title {
      font-size: 16px;
      color: #303133;
      margin-bottom: 4px;
    }
    .el-divider {
      margin: 12px 0;
    }
    .info-descriptions {
      margin-bottom: 8px;
      ::v-deep .el-descriptions-item__label {
        font-weight: 500;
        color: #606266;
      }
      ::v-deep .el-descriptions-item__content {
        color: #303133;
      }
      // 移动端调整列数
      @media (max-width: 768px) {
        ::v-deep .el-descriptions-item {
          display: block;
          .el-descriptions-item__label,
          .el-descriptions-item__content {
            display: inline-block;
            width: auto;
          }
          .el-descriptions-item__label {
            min-width: 100px;
            font-weight: 600;
          }
        }
      }
    }
    ::v-deep .el-form-item {
      margin-bottom: 16px;
      .el-form-item__label {
        font-size: 13px;
        @media (max-width: 768px) {
          width: 80px !important;
          font-size: 12px;
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .el-dialog {
    margin: 20px auto !important;
    .el-dialog__header {
      padding: 16px 20px 10px;
      .el-dialog__title {
        font-size: 16px;
      }
    }
    .el-dialog__body {
      padding: 16px 20px;
    }
  }
}
</style>
